import axios from "axios";
// eslint-disable-next-line no-unused-vars
import router from "../router";
import { errorMsg } from "@/helpers/alerts.js";
// eslint-disable-next-line no-unused-vars
import { GetToken } from "@/helpers/encrypt";
import { useAuthStore } from "@/store/auth";
// eslint-disable-next-line no-unused-vars
// const url = "http://127.0.0.1:8000/qep";
const url = "https://ialqp.dazzzlinggems.com/qep";
// const  url = "https://markplc.basmeemis.org/qep";
export const AxiosClient = axios.create({
  baseURL: url,
});
AxiosClient.interceptors.request.use((config) => {
  const token = GetToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
AxiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      throw Error("Network error, Check your network and try again!");
    }
    if (error.response.status === 401) {
      // Handle 401 error (Unauthorized)
      useAuthStore().logout();
      router.push({ name: "login" });
    } else if (error.response.status === 403) {
      errorMsg(error.response.data.message).then(() => {
        router.push({ name: "dashboard" });
      });
    } else if (error.response.status === 409) {
      throw Error(error.response.data.message);
    } else if (error.response.status === 463) {
      if (error?.response?.data) {
        throw Error(error?.response?.data?.message);
      } else if (error?.response?.message) {
        throw Error(error?.response?.message);
      } else {
        throw Error(error?.message);
      }
    } else if (error.response.status === 422) {
      if (error?.response?.data) {
        throw Error(error?.response?.data?.message);
      } else if (error?.response?.message) {
        throw Error(error?.response?.message);
      } else {
        throw Error(error?.message);
      }
    }else if (error.response.status === 500) {
      if (error?.response?.data) {
        throw Error(error?.response?.data?.message);
      } else if (error?.response?.message) {
        throw Error(error?.response?.message);
      } else {
        throw Error(error?.message);
      }
    }
    return Promise.reject(error);
  },
);
